import { OrdersApiRepository } from 'silal_app_base_react/src/data/repositories/orders_repository';
import { sellerAxiosInstance } from 'silal_app_base_react/src/utils/axios/axios';

const OrdersRepository = OrdersApiRepository.getInstance(sellerAxiosInstance);

export default OrdersRepository;
